import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';
import 'moment/locale/es';

const styles = StyleSheet.create({
   
    titleContainer:{
      
        marginTop: 14,
    },
    reportDate:{
      color: '#000000',
      letterSpacing: 0,
      fontSize: 10,
      textAlign: 'left',
      fontStyle: 'bold',
      fontFamily:"Times-Roman",
      fontWeight: "bold",
      margin: 8,
  },
    reportTitle:{
        color: '#000000',
        letterSpacing: 0,
        fontSize: 12,
        textAlign: 'center',
        textTransform: 'uppercase',
        fontStyle: 'bold',
        fontFamily:"Times-Roman",
        fontWeight: "bold",
        alignContent: "center",
        margin: 8,
    }
  });


  const InvoiceTitle = ({title, dateAttend}) => (
    <View style={styles.titleContainer}>
         <Text style={styles.reportDate}>Fecha de atención: {moment(dateAttend).locale('es').format('MMMM D YYYY')}</Text>
        <Text style={styles.reportTitle}>{title}</Text>
    </View>
  );
  
  export default InvoiceTitle